import { OperationTypes } from 'sigma-mappings';

const lookup = vm => ([
  {
    id: OperationTypes.CHANGE,
    name: vm.$t('reports.operations-history.types.change'),
  },
  {
    id: OperationTypes.EXCLUSION,
    name: vm.$t('reports.operations-history.types.exclusion'),
  },
  {
    id: OperationTypes.INCLUSION,
    name: vm.$t('reports.operations-history.types.inclusion'),
  },
  {
    id: OperationTypes.LOGIN,
    name: vm.$t('reports.operations-history.types.login'),
  },
]);

export default lookup;
